/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'დღეს',
  now: 'ახლა',
  backToToday: 'მიმდინარე თარიღი',
  ok: 'დიახ',
  clear: 'გასუფთავება',
  month: 'თვე',
  year: 'წელი',
  timeSelect: 'აირჩიეთ დრო',
  dateSelect: 'აირჩიეთ თარიღი',
  weekSelect: 'აირჩიეთ კვირა',
  monthSelect: 'აირჩიეთ თვე',
  yearSelect: 'აირჩიეთ წელი',
  decadeSelect: 'აირჩიე ათწლეული',
  yearFormat: 'YYYY',
  dateFormat: 'D.M.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D.M.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'წინა თვე (PageUp)',
  nextMonth: 'შემდეგი თვე (PageDown)',
  previousYear: 'წინა წელი (Control + left)',
  nextYear: 'შემდეგი წელი (Control + right)',
  previousDecade: 'წინა ათწლეული',
  nextDecade: 'შემდეგი ათწლეული',
  previousCentury: 'წინა საუკუნე',
  nextCentury: 'შემდეგი საუკუნე'
};
